<template>
    <div class="overflow-x-auto">
        <table class="table">
            <thead>
                <tr>
                    <th>Projektnamn</th>
                    <th>Status</th>
                    <th class="text-right">Adresser</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="project in projects">
                    <td>
                        <a :href="route('admin.sales-projects.show', project)">{{ project.name }}</a>
                    </td>
                    <td>
                        <!-- eslint-disable vue/no-v-html -->
                        <span v-html="project.status_icon_html_dot" />
                        <span class="ml-md">
                            {{ project.status_label }}
                        </span>
                    </td>
                    <td class="text-right">
                        {{ project.addresses_count }}
                    </td>
                    <td class="text-right">
                        <anonymize-project-button
                            v-if="! project.anonymization_request && authorizedToAnonymize"
                            :project="project"
                            @anonymized="updateProjects"
                        />
                        <delete-anonymization-request-button
                            v-if="project.anonymization_request && authorizedToAnonymize"
                            :anonymization-request="project.anonymization_request"
                            size="small"
                            @deleted="updateProjects"
                        >
                            Avbryt anonymisering
                        </delete-anonymization-request-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import AnonymizeProjectButton from './Buttons/AnonymizeProjectButton';
    import DeleteAnonymizationRequestButton from './Buttons/DeleteAnonymizationRequestButton';

    export default {
        components: {
            AnonymizeProjectButton,
            DeleteAnonymizationRequestButton,
        },
        props: {
            projects: {
                type: Array,
                required: true,
            },
            authorizedToAnonymize: {
                type: Boolean,
                required: true,
            },
        },

        methods: {
            updateProjects() {
                this.$emit('projects-updated');
            },
        },
    };
</script>
